import { render, staticRenderFns } from "./classement_carnet.vue?vue&type=template&id=ec994bee&"
import script from "./classement_carnet.vue?vue&type=script&lang=js&"
export * from "./classement_carnet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports